export const MAX_CAROUSEL_THUMBNAILS_WIDTH = 880;
export const CAROUSEL_THUMBNAILS_NUMBER = 5;
export const TITLE_FORMAT = '{year} {make} {model}';
export const TITLE_DATA = ['length'];
